/**
 * DISCLAIMER COMPONENT
 * 
 * Componente reutilizable para mostrar avisos legales
 * Usado en Footer y Resultados de Cálculos
 */

import React from 'react'
import { AlertCircle } from 'lucide-react'

export default function Disclaimer({ type = 'footer' }) {
  const disclaimerFooter = 'Simulador previsional ajustado a la normativa vigente (DNU 274/2024). Los resultados obtenidos son estimaciones técnicas de carácter orientativo. La resolución final y el cálculo definitivo de los haberes son facultad exclusiva de ANSES o la caja otorgante correspondiente.'

  const disclaimerResults = 'AVISO LEGAL: Este cálculo se basa en la información proporcionada por el usuario y en la aplicación de las fórmulas legales vigentes al 1 de mayo de 2026 (Ley 24.241 y DNU 274/2024). La plataforma no se responsabiliza por errores derivados de la carga incorrecta de datos o cambios legislativos posteriores. Se recomienda la revisión del informe por un profesional matriculado.'

  const content = type === 'results' ? disclaimerResults : disclaimerFooter

  if (type === 'footer') {
    return (
      <div className="border-t border-gray-300 pt-4 mt-8">
        <p className="text-xs text-gray-600 leading-relaxed text-justify">
          {content}
        </p>
      </div>
    )
  }

  if (type === 'results') {
    return (
      <div className="bg-amber-50 border-l-4 border-amber-400 p-4 rounded my-6">
        <div className="flex gap-3">
          <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
          <p className="text-sm text-gray-700 leading-relaxed">
            {content}
          </p>
        </div>
      </div>
    )
  }

  return null
}
